import { useHome } from './hooks'

export const Home = () => {
  // NOTE: redirect user to jobs page, in the future
  // we might have a proper content for the home page
  useHome()

  return null
}
